export const DESKTOP = 'DESKTOP';
export const DESKTOP_AIR_PM = 'DESKTOP_AIR_PM';
export const DESKTOP_IOLITE = 'DESKTOP_IOLITE';
export const MOBILE = 'MOBILE';
export const MOBILE_WEB = 'MOBILE_WEB';
export const MOBILE_NATIVE_IOS = 'MOBILE_NATIVE_IOS';
export const MOBILE_NATIVE_ANDROID = 'MOBILE_NATIVE_ANDROID';
export const NATIVE_ANDROID_CASINO = 'NATIVE_ANDROID_CASINO';
export const NATIVE_IOS_CASINO = 'NATIVE_IOS_CASINO';
export const NATIVE_IOS_IOLITE = 'NATIVE_IOS_IOLITE';
export const NATIVE_ANDROID_IOLITE = 'NATIVE_ANDROID_IOLITE';
export const MOBILE_IOLITE = 'MOBILE_IOLITE';
export const PWA = 'PWA';
export const CLOAK = 'CLOAK';

export const DESKTOP_CHANNELS = [DESKTOP_AIR_PM, DESKTOP, DESKTOP_IOLITE];
export const MOBILE_CHANNELS = [MOBILE, MOBILE_WEB, MOBILE_IOLITE, PWA, CLOAK];
export const NATIVE_CHANNELS = [
  MOBILE_NATIVE_IOS,
  MOBILE_NATIVE_ANDROID,
  NATIVE_ANDROID_CASINO,
  NATIVE_IOS_CASINO,
  NATIVE_IOS_IOLITE,
  NATIVE_ANDROID_IOLITE,
];
